import { Grow, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { NavButton, StyledBox } from "./RcAnalysis/WhyAnalysis";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import { BsFillBookmarkCheckFill } from "react-icons/bs";

export const WhyWhyDiagramViewOnlyMode = ({ ncrData }) => {

  const findWhyHeight = (char) => {
    return ncrData?.why_why_analysis?.some((item) => item?.content?.length > char)
  }

  return (
    <Grow
      in={true}
      style={{ transformOrigin: '0 0 0' }}
      timeout={1000}
    >
      <Box sx={{ p: 5 }}>
        <Box sx={{ mb: findWhyHeight(200) ? 5 : findWhyHeight(100) ? 20 : 25 }}>
          <Box sx={{ width: "100%", padding: "10px 0" }}>
            <Box sx={{ padding: 4, margin: 'auto', width: "100%" }}>
              <Stack direction={{ xs: "column", md: "row" }} rowGap={5} alignItems="flex-start">
                {ncrData?.why_why_analysis?.map((item, index) => {
                  const textFiledStyles = item?.is_submitted ? {
                    minHeight: "100px",
                    backgroundColor: "#c0392b",
                    color: "white",
                    display: "flex",
                    alignItems: "start",
                    flexWrap: "wrap",
                    borderRadius: "8px",
                  } : {}

                  return (
                    <div key={item?.id} style={{ width: '300px' }}>
                      <div style={{ width: "100%" }}>
                        <div style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: "start",
                          alignItems: "center",
                        }}>
                          <div style={{
                            border: '3px solid rgba(128, 128, 128, 0.2)',
                            width: '65%',
                            display: 'flex',
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "10%",
                            padding: '8px 10px 8px 5px'
                          }}>
                            <StyledBox bgcolor={item?.color} idx={index} style={{ width: "100%" }}>
                              <Typography variant="h6" fontWeight="bold" sx={{fontFamily: 'Lato, sans-serif'}}>
                                {item?.title}
                              </Typography>
                            </StyledBox>
                          </div>
                          {index < ncrData?.why_why_analysis?.length - 1 && (
                            <div style={{
                              width: '35%',
                              paddingLeft: "5px",
                              height: "3px",
                              backgroundColor: "#e5e7e9",
                              position: "relative"
                            }}>
                              <div style={{ position: "absolute", transform: 'translate(-50%,-50%)', left: "50%", top: "5px" }}>
                                <MdOutlineArrowForwardIos style={{ fontSize: 32, color: item?.color, marginLeft: "12px", fontWeight: 900 }} />
                              </div>
                            </div>
                          )}
                        </div>

                        <div style={{
                          width: '60%',
                          display: 'flex',
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: '10px',
                          marginLeft: "2px"
                        }}>
                          {index !== 4 && (
                            <NavButton
                              title="Next"
                              icon={<SkipNextIcon style={{ fontSize: "25px" }} />}
                              disabled={!item?.content || (5 !== index)}
                            />
                          )}

                          {index !== 0 && (
                            <NavButton
                              title="Previous"
                              icon={<SkipPreviousIcon style={{ fontSize: "25px" }} />}
                              disabled={(5 !== index)}
                            />
                          )}


                          {index === 0 &&
                            <NavButton
                              title="Submit"
                              icon={<BsFillBookmarkCheckFill style={{ fontSize: "22px" }} />}
                              disabled={!item?.content}
                            />
                          }

                          {index !== 0 &&
                            <NavButton
                              title="Submit"
                              icon={<BsFillBookmarkCheckFill style={{ fontSize: "22px" }} />}
                              disabled={!item?.content}
                            />
                          }
                        </div>

                        <div style={{
                          width: "63%",
                          marginTop: "10px",
                          minHeight: '40px',
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div style={{
                            width: "100%",
                            minHeight: "100px",
                            backgroundColor: "rgba(128, 128, 128, 0.2)",
                            display: "flex",
                            justifyContent: "flex-start",
                            flexWrap: "wrap",
                            borderRadius: "8px",
                            padding: "10px",
                            ...textFiledStyles
                          }}>
                            <Typography style={{
                              fontFamily: 'Lato, sans-serif',
                              width: "100%",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              fontSize: "15px",
                            }}>
                              {item?.content}
                            </Typography>
                          </div>
                        </div>
                        {item?.is_submitted && <Typography sx={{
                          fontFamily: 'Lato, sans-serif',
                          width: "100%",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                          fontSize: "15px",
                          marginTop: "10px",
                          fontWeight: 400,
                          ml: 1
                        }}>
                          FINAL ROOT CAUSE
                        </Typography>
                        }
                      </div>
                    </div>
                  )
                })}
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </Grow>
  )
}